/**
 * Collapsible Content Handler
 * Processes [collapse] shortcodes in product descriptions and makes them interactive
 */

(function() {
  'use strict';

  // Process shortcodes in the content
  function processShortcodes(container) {
    if (!container) return;

    let content = container.innerHTML;
    let shortcodeIndex = 0;
    let hasShortcodes = false;

    // First, clean up shortcodes that might be wrapped in <p> tags
    // Remove <p> tags around [collapse] and [/collapse] tags
    content = content.replace(/<p[^>]*>(\s*\[collapse[^\]]+\])\s*<\/p>/gi, '$1');
    content = content.replace(/<p[^>]*>(\s*\[\/collapse\])\s*<\/p>/gi, '$1');

    // Now process the shortcodes normally
    const shortcodeRegex = /\[collapse\s+title="([^"]+)"\]([\s\S]*?)\[\/collapse\]/gi;
    
    content = content.replace(shortcodeRegex, function(match, title, innerContent) {
      hasShortcodes = true;
      const id = 'collapsible-' + Date.now() + '-' + shortcodeIndex++;
      const trimmedContent = innerContent.trim();
      
      return `
        <div class="collapsible-content" data-collapsible data-expanded="false" data-id="${id}">
          <button 
            class="collapsible-content__toggle" 
            type="button" 
            aria-expanded="false"
            aria-controls="${id}"
          >
            <span class="collapsible-content__title">${title}</span>
            <span class="collapsible-content__chevron" aria-hidden="true">
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
          <div 
            class="collapsible-content__content" 
            id="${id}"
            aria-hidden="true"
          >
            ${trimmedContent}
          </div>
        </div>
      `;
    });

    // Only update if we found shortcodes
    if (hasShortcodes) {
      container.innerHTML = content;
      initializeCollapsibles(container);
    }
  }

  // Initialize collapsible functionality
  function initializeCollapsibles(container) {
    const collapsibles = container.querySelectorAll('[data-collapsible]');
    
    collapsibles.forEach(function(collapsible) {
      const toggle = collapsible.querySelector('.collapsible-content__toggle');
      const content = collapsible.querySelector('.collapsible-content__content');
      
      if (!toggle || !content) return;

      toggle.addEventListener('click', function() {
        const isExpanded = collapsible.getAttribute('data-expanded') === 'true';
        const newState = !isExpanded;
        
        collapsible.setAttribute('data-expanded', newState);
        toggle.setAttribute('aria-expanded', newState);
        content.setAttribute('aria-hidden', !newState);
      });
    });
  }

  // Initialize on DOM ready
  function init() {
    // Process product descriptions - try multiple common selectors
    const selectors = [
      '.product__description',
      '.product-description',
      '[class*="product-description"]',
      '.rte',
      '.product__text',
      '.product-text',
      '[class*="product__text"]',
      'main .rte',
      '[data-product-description]',
      '.product-single__description',
      '.product__content',
      '.product-content'
    ];
    
    let foundContainers = new Set();
    
    selectors.forEach(function(selector) {
      try {
        const containers = document.querySelectorAll(selector);
        containers.forEach(function(container) {
          if (!foundContainers.has(container)) {
            foundContainers.add(container);
            processShortcodes(container);
          }
        });
      } catch (e) {
        // Invalid selector, skip
      }
    });

    // Also process any content with the data-collapsible-process attribute
    const customContainers = document.querySelectorAll('[data-collapsible-process]');
    customContainers.forEach(function(container) {
      processShortcodes(container);
    });

    // Fallback: search entire main content area for shortcodes if nothing found
    if (foundContainers.size === 0) {
      const mainContent = document.querySelector('main, #MainContent, .main-content, [role="main"]');
      if (mainContent) {
        // Search for any element containing the shortcode pattern
        const allElements = mainContent.querySelectorAll('*');
        allElements.forEach(function(el) {
          if (el.innerHTML && el.innerHTML.includes('[collapse')) {
            processShortcodes(el);
          }
        });
      }
    }
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after dynamic content loads (for AJAX product pages)
  if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
    document.addEventListener('shopify:section:load', init);
  }
})();

